// extracted by mini-css-extract-plugin
export default {"container":"Error_container__ABNH+","err":"Error_err__DsenX","text1":"Error_text1__zlEqw","text2":"Error_text2__x9x5Q","main":"Error_main__aWw-r"};